export default __webpack_public_path__ + "static/media/004-B-tech.f1ade65a.svg";